<template>
    <WorkspaceNodeCard
        v-if="isWorkspace(node)"
        :key="'workspace'+node.id"
        :node="node"
        :depth="depth"
        :depth-color="getDepthColor(depth)"
        :selected-space-id="selectedSpaceId"
        @remove="emit('remove')"
        @update="emit('update')"
        @expand="emit('expand')"
    />
    <GraphNodeCard
        v-else
        :key="'graph' + node.id"
        :node="node"
        :last="last"
        :depth="depth"
        :depth-color="getDepthColor(depth)"
        :selection-enabled="selectionEnabled"
        :reorder-enabled="reorderEnabled"
        v-model:selected="selectedElements"
        @drag-handle-down="emit('drag-handle-down', $event)"
        @remove="emit('remove')"
        @update="emit('update')"
    />
</template>

<script setup>
import WorkspaceModel from "@/src/model/WorkspaceModel";
import GraphModel from "@/src/model/GraphModel";
import WorkspaceNodeCard from './WorkspaceNodeCard.vue';
import GraphNodeCard from './GraphNodeCard.vue';

const props = defineProps({
    node: WorkspaceModel | GraphModel,
    depth: Number,
    allowDelete: {
        type: Boolean,
        default: true,
    },
    selectedSpaceId: Number,
    selectionEnabled: {
        type: Boolean,
        default: false,
    },
    reorderEnabled: {
        type: Boolean,
        default: false,
    },
    last: {
        type: Boolean,
        default: false,
    },
});

const selectedElements = defineModel('selected', { default: [] })

const emit = defineEmits(['remove', 'update', 'expand', 'drag-handle-down']);

const isWorkspace = node => node instanceof WorkspaceModel;

const getDepthColor = (depth) => {
    const colors = ['#ffcccc', '#cce5ff', '#d5ffcc', '#fff5cc', '#e5ccff'];
    return colors[depth % colors.length];
};
</script>
